import { render, staticRenderFns } from "./lista.vue?vue&type=template&id=394ef780&scoped=true&"
import script from "./lista.vue?vue&type=script&lang=js&"
export * from "./lista.vue?vue&type=script&lang=js&"
import style0 from "./lista.vue?vue&type=style&index=0&id=394ef780&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394ef780",
  null
  
)

export default component.exports